import { render, staticRenderFns } from "./TipolugarModalEdicion.vue?vue&type=template&id=dbdb0b6e&scoped=true&"
import script from "./TipolugarModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./TipolugarModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./TipolugarModalEdicion.vue?vue&type=style&index=0&id=dbdb0b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdb0b6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('dbdb0b6e', component.options)
    } else {
      api.reload('dbdb0b6e', component.options)
    }
    module.hot.accept("./TipolugarModalEdicion.vue?vue&type=template&id=dbdb0b6e&scoped=true&", function () {
      api.rerender('dbdb0b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/TipolugarModalEdicion.vue"
export default component.exports